{
  "schemaVersion": 1,
  "application": "service-portal",
  "fixtureVersion": "service-portal-guided-fixture-v2",
  "schedule": {
    "cron": "0 16 * * *",
    "timeZone": "Asia/Manila",
    "utcOffset": "UTC+08:00",
    "localTime": "12:00 AM"
  },
  "storage": {
    "kv": {
      "binding": "DEMO_STATE",
      "currentKeyPattern": "generation:{resetGeneration}:session:{stateId}",
      "canonicalSentinelPattern": "generation:{resetGeneration}:canonical-fixture",
      "cleanupPrefixPattern": "generation:{previousGeneration}:session:",
      "sessionTtlSeconds": 604800,
      "authoritativeReset": "Atomically advance the reset generation in the coordinator. Prior generations are never read again.",
      "physicalCleanup": "Best-effort paginated deletion follows the generation flip. Expiry is a bounded fallback and correctness never depends on KV list consistency."
    },
    "durableObject": {
      "binding": "DEMO_RESET_COORDINATOR",
      "className": "DemoResetCoordinator",
      "contents": "Reset metadata, phase checkpoints, message deduplication, outbox entries, failures, and short write leases only."
    },
    "browser": {
      "state": "The signed session keeps its opaque state identifier so the analyst-to-administrator handoff remains supported.",
      "invalidation": "The shared reset notice observes generation changes and invalidates cached queries; reloads read only the current generation."
    },
    "externalSystems": []
  },
  "visitorDataRemoved": [
    "Visitor-created imagery requests",
    "Prepared download records",
    "Administrator order-status and operator-note mutations",
    "Per-session reset mutations"
  ],
  "canonicalDataRestored": {
    "orders": 4,
    "downloads": 3,
    "sentinelOrderId": "PO-DEMO-2026-0421",
    "sentinelDownloadId": "DL-DEMO-0096",
    "workflow": "Authored analyst request fixture with same-browser administrator handoff"
  },
  "intentionallyPreserved": [
    "Synthetic imagery catalogue and public content",
    "Authored demo account definitions and credentials",
    "Opaque signed browser session and role-handoff state identifier",
    "Schema and migration metadata",
    "Worker configuration, secrets, integration credentials, and deployment history",
    "Canonical fixture definitions"
  ],
  "ordering": [
    "Create a unique run record and enter write maintenance in the Durable Object",
    "Advance the authoritative reset generation",
    "Page through the prior generation KV prefix and delete visible keys when not in dry-run mode",
    "Verify fixture definitions and write a current-generation canonical sentinel",
    "Commit successful completion and reopen writes"
  ],
  "referentialIntegrity": "Orders and downloads are restored together as one validated KV document; every canonical download references an authored scene and either a current fixture order or the documented historical PO-DEMO order namespace.",
  "interruptedRunRecovery": "The coordinator persists the expected phase, sequence number, cleanup cursor, and outbox before acknowledging. A repeated Cron delivery or operator retry flushes pending outbox work, while duplicate and out-of-order messages are safe.",
  "writeBehaviorDuringReset": "Reads remain available from the current generation. New visitor mutations fail closed with an honest maintenance error while a non-dry-run reset is active. Short per-session write leases serialize accepted mutations; writes completed after a generation change are rejected and can only have touched the unreachable prior namespace.",
  "verificationCriteria": [
    "Canonical order and download counts match this manifest",
    "Sentinel order and download records exist",
    "Every canonical scene reference exists in the synthetic catalogue",
    "A current-generation canonical sentinel is written",
    "No active reset remains before writes reopen"
  ],
  "rollbackOrRecovery": "Generations are monotonic and are never rolled back. If cleanup or verification fails, repair the fixture or transient dependency and redeliver the checkpointed message. A later authorized reset advances to a fresh generation; unreachable generations expire automatically.",
  "productionActivation": "The routed top-level Worker is fail-closed with DEMO_RESET_ENABLED=false while the canonical Cron, Queue, and dead-letter consumers are attached as a dark topology. Disabled deliveries retry without acknowledging. The deployable reset-staging environment has a distinct Worker, auto-provisioned staging-only KV namespace, Queue, DLQ, and Worker-scoped Durable Object namespace and requires a 32-byte-minimum DEMO_RESET_OPERATOR_SECRET. Activation requires isolated staging dry/full evidence, a drain-first disable plan, recovery ownership, monitoring, explicit operator approval, and a separate production change to DEMO_RESET_ENABLED=true."
}
